import PurchaseConfiguratorVariantController from 'src/controllers/shopping/purchase_configurator/purchase_configurator_variant_controller';

// Just here to connect up to the correct ERB view.
// Inherits all behaviour from the base class.
export default class PurchaseConfiguratorUomPricingDetailsController extends PurchaseConfiguratorVariantController {}
